/**
 * Accordion Block Functionality
 *
 * Handles accordion item expansion and collapse for the accordion block.
 *
 * @package Karuna_Hospice
 */

/**
 * Initialize accordion functionality
 */
export function initAccordion() {
	const accordionBlocks = document.querySelectorAll( '[data-accordion-block]' );

	if ( ! accordionBlocks.length ) {
		return;
	}

	accordionBlocks.forEach( ( block ) => {
		const accordionButtons = block.querySelectorAll( '.accordion-block__item-button' );
		const accordionContents = block.querySelectorAll( '.accordion-block__item-content' );

		if ( ! accordionButtons.length || ! accordionContents.length ) {
			return;
		}

		accordionButtons.forEach( ( button ) => {
			button.addEventListener( 'click', () => {
				const buttonIndex = parseInt( button.getAttribute( 'data-accordion-index' ), 10 );
				const isExpanded = button.getAttribute( 'aria-expanded' ) === 'true';
				const content = block.querySelector(
					`.accordion-block__item-content[data-content-index="${ buttonIndex }"]`
				);
				const plusIcon = button.querySelector( '.accordion-block__item-icon-plus' );
				const minusIcon = button.querySelector( '.accordion-block__item-icon-minus' );

				if ( ! content ) {
					return;
				}

				if ( isExpanded ) {
					// Collapse this item
					button.setAttribute( 'aria-expanded', 'false' );
					content.classList.add( 'hidden' );
					if ( plusIcon ) {
						plusIcon.classList.remove( 'hidden' );
					}
					if ( minusIcon ) {
						minusIcon.classList.add( 'hidden' );
					}
				} else {
					// Expand this item
					// First, collapse all other items
					accordionButtons.forEach( ( btn ) => {
						const btnIndex = parseInt( btn.getAttribute( 'data-accordion-index' ), 10 );
						if ( btnIndex !== buttonIndex ) {
							const btnContent = block.querySelector(
								`.accordion-block__item-content[data-content-index="${ btnIndex }"]`
							);
							const btnPlusIcon = btn.querySelector( '.accordion-block__item-icon-plus' );
							const btnMinusIcon = btn.querySelector( '.accordion-block__item-icon-minus' );

							btn.setAttribute( 'aria-expanded', 'false' );
							if ( btnContent ) {
								btnContent.classList.add( 'hidden' );
							}
							if ( btnPlusIcon ) {
								btnPlusIcon.classList.remove( 'hidden' );
							}
							if ( btnMinusIcon ) {
								btnMinusIcon.classList.add( 'hidden' );
							}
						}
					} );

					// Then expand this item
					button.setAttribute( 'aria-expanded', 'true' );
					content.classList.remove( 'hidden' );
					if ( plusIcon ) {
						plusIcon.classList.add( 'hidden' );
					}
					if ( minusIcon ) {
						minusIcon.classList.remove( 'hidden' );
					}
				}
			} );
		} );
	} );
}













